import { Component, OnInit, Input, Output, EventEmitter, Inject, LOCALE_ID } from '@angular/core';
import { formatDate } from '@angular/common';
import { DiariseOptionModel } from '../../../models/diarise-option.model';
import { DiariseUnit } from '../../../enums/diarise-unit';
import { DiariseOptionClickEvent } from '../../../events/diarise-option-click-event';
import { DiariseReasonModel } from '../../../models/diarise-reason.model';
import { DiariseWorkEvent } from '../../../events/diarise-work-event';


export class E5coreUiWorkDiariseBaseComponent implements OnInit {

  @Output() periodChange = new EventEmitter<DiariseOptionClickEvent>() ;
  @Output() diariseWork = new EventEmitter<DiariseWorkEvent>();  
  @Output() reasonTextChange = new EventEmitter<DiariseWorkEvent>() ;
  @Output() reasonChange = new EventEmitter<DiariseWorkEvent>();
  @Output() dateChange = new EventEmitter<DiariseWorkEvent>();
  @Output() timeChange = new EventEmitter<string>();
  @Input() reasons:DiariseReasonModel[];
  @Input() periodOptions:DiariseOptionModel[];
  @Input() displayedDate:Date;
  @Input() displayedTime:string;
  @Input() diariseReasonPropertyId:string;
  @Input() diariseReasonTextValue:string;
  @Input() diariseReasonPlaceHolder:string = "Enter diarise reason here";
  @Input() diariseReasonOption:string;
  @Input() showDiariseTime: boolean = true;
  @Input() showDiariseButton: boolean = true;
  @Input() showDiariseReasonDropdown: boolean = true;
  @Input() showDiariseReasonText: boolean = true;
  diariseDate : Date;
  diarisePeriod : DiariseOptionModel;
  
  constructor(@Inject(LOCALE_ID) private locale: string) {}
  ngOnInit() {
  }

  onDiarisePeriodOptionClick(diarisePeriodOption: DiariseOptionModel)
  {
    let optionClickEvent = new DiariseOptionClickEvent(diarisePeriodOption);
    this.diarisePeriod = diarisePeriodOption;
    this.periodChange.emit(optionClickEvent);
  }

  onDiariseReasonTextChange($event: any) 
  {
    this.diariseReasonTextValue = $event;
    this.reasonTextChange.emit($event) ;
  }

  onDiariseReasonChange($event: any)
  {
    this.diariseReasonOption = $event;
    this.reasonChange.emit($event);
  }

  onDiariseButtonClick($event: DiariseWorkEvent)
  {
    this.diariseWork.emit($event);
  }

  onDateChange($event:DiariseWorkEvent)
  {
    this.dateChange.emit($event);
  }
  onTimeChange($event:string)
  {
    this.displayedTime = $event;
    this.timeChange.emit($event);
  }
}
